import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { doForgotPassword } from "../../../modules/auth/stores/thunk";
import "./Auth.scss";

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.common);
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      navigate("/");
    }
  }, [message, navigate]);

  const handleSubmit = (params) => {
    dispatch(doForgotPassword(params));
  };

  return (
    <div className="ForgotPasswordForm">
      <Form
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
      >
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo.svg`}
              alt="logo"
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Återställ Lösenord</div>
          <div className="SubTitle">
            Fyll i din e-postadress för att återställa lösenordet 
          </div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Användarnamn"
            name="email"
            hasFeedback
            rules={[
              { type: "email", message: "Invalid Email" },
              { required: true, message: "Required" },
            ]}
          >
            <Input size="large" placeholder="namn@företag.se" />
          </Form.Item>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Bekräfta återställning av lösenord
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
